import { render } from "./Utilities.vue?vue&type=template&id=28b4317b"
import script from "./Utilities.vue?vue&type=script&lang=js"
export * from "./Utilities.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__